import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { links } from '../../Arrays'
import { Logo } from '../../Components/Logo/Logo'
import { Drawer } from './Drawer'
import './Navbar.css'
export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false)
  const location = useLocation()
  const [visible, setVisible] = useState(false)
  const scrollTimer = useRef(null)

  const handleScroll = useCallback(() => {
    if (scrollTimer.current) return
    scrollTimer.current = setTimeout(() => {
      setScrolled(window.scrollY > 50)
      scrollTimer.current = null
    }, 50)
  }, [])

  const linksrow = links.map(link => {
    return (
      <a key={link.anchor} onClick={() => setVisible(false)} href={link.anchor} className={location.hash === link.anchor ? 'activenavlink' : ''}>{link.text}</a>
    )
  })

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
      if (scrollTimer.current) clearTimeout(scrollTimer.current)
    }
  }, [handleScroll])

  return (
    <>
    <nav aria-label="Main navigation" className={`navbar header ${scrolled ? `scrollednav` : ''}`}>
      <Logo img={`https://mcusercontent.com/013dcbdd2fe47e8cd211361cd/images/${!scrolled ? '5871654b-35a6-6cd2-abca-123ad5db13f8' : 'eea81702-84b3-ca0e-13de-69763f3fb2a0'}.png`}/>
      <div className="navlinksrow flexrow">
        {linksrow}
      </div>
      <button
        aria-label={visible ? 'Close navigation menu' : 'Open navigation menu'}
        aria-expanded={visible}
        aria-controls="mobile-drawer"
        className={`${visible ? 'menux' : ''} menubars`}
        onClick={() => setVisible(!visible)}
      >
        <div className="bar" aria-hidden="true"></div>
        <div className="bar bar2" aria-hidden="true"></div>
        <div className="bar" aria-hidden="true"></div>
      </button>
    </nav>
    <Drawer setVisible={setVisible} navlinksrow={linksrow} visible={visible}/>
    <button
      aria-label="Scroll to top"
      className={`scrolltotop ${scrolled ? 'visiblebtn' : ''}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      tabIndex={scrolled ? 0 : -1}
    >
      <i className="fa fa-chevron-up" aria-hidden="true"></i>
    </button>
    </>
  )
}